'use client';
import React from 'react';
import classNames from 'classnames';

import { TypeBlockClientTestimonial } from '@fm-nx/contentful-types';
import { useContentfulInspectorMode, useContentfulLiveUpdates } from '@contentful/live-preview/react';

type ClientTestimonialProps = TypeBlockClientTestimonial<'WITHOUT_UNRESOLVABLE_LINKS'> & {
    mode?: 'dark' | 'light';
};

export const ClientTestimonial = (props: ClientTestimonialProps) => {
    const { fields, mode = 'dark' } = props;
    const updatedBlock = useContentfulLiveUpdates(props);
    const inspectorProps = useContentfulInspectorMode({ entryId: updatedBlock.sys.id });
    if (!fields) return null;

    const isDark = mode === 'dark';

    return (
        <div
            className={classNames('relative w-full mx-auto max-w-container', {
                'bg-gray-900': isDark,
            })}
        >
            <div className="py-20 mx-6 md:py-40 md:grid md:grid-cols-14">
                <div className="col-span-12 col-start-2">
                    <h5
                        className={classNames('mb-14 h5 overline', {
                            'text-white': isDark,
                            'text-gray-900': !isDark,
                        })}
                    >
                        Client Testimonial
                    </h5>
                    <figure>
                        <blockquote>
                            <p
                                {...inspectorProps({
                                    fieldId: 'quote',
                                })}
                                className={classNames(
                                    'text-4xl font-bold leading-tight tracking-tight lg:text-6xl font-headline',
                                    {
                                        'text-white': isDark,
                                        'text-gray-900': !isDark,
                                    }
                                )}
                            >
                                &ldquo;{updatedBlock?.fields.quote}&rdquo;
                            </p>
                        </blockquote>
                        <figcaption
                            className={classNames('mt-14', {
                                'text-white': isDark,
                                'text-gray-900': !isDark,
                            })}
                        >
                            <span
                                className="block h-xs"
                                {...inspectorProps({
                                    fieldId: 'authorName',
                                })}
                            >
                                {updatedBlock?.fields.authorName}
                            </span>
                            <span className="block mt-4 p-xl">
                                {updatedBlock.fields?.client?.fields?.name}
                                {updatedBlock?.fields.authorTitle && `, ${updatedBlock.fields.authorTitle}`}
                            </span>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </div>
    );
};

export default ClientTestimonial;
